import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import { Input, Select, Form, Tabs, Button, Table ,Menu,Row,Col,Breadcrumb,Icon,message,Radio,Rate,Checkbox,Modal} from 'antd';
/** PERSONAL */
import API from '../../../../API/api';
import KnowledgeBox from '../../set_tag/question_tag_detail/knowledge_box/view'
import Question from '../../../../entry_question_editor/question/question_view/view';

class HitTag extends Component {
    state = {
        question:{},
        tab:'normal',
    }
    componentWillMount() {
        this.state.question_id = window.location.href.split('/').pop()
        this.getQuestion()
    }
    componentDidUpdate(prevProps, prevState) {
    }


    getQuestion = ()=>{
        if(!this.state.question_id){return}
        let data = {
            question_id:this.state.question_id,
        }
        axios.post(API.QSELECTTNEW_QUESTION_DETAIL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                this.setState({question:res.data});
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });
    }
    setTag = (cb)=>{
        let URL = API.QSELECTTNEW_TASK_QUESTION_SUBMIT

        let relate_list = []
        this.state.question.select.forEach((val)=>{
            let obj = {
                type:val.type,
                list:val.selected.map(d=>({well:d.well,id:d.id}))
            }
            relate_list.push(obj)
        })
        let data = {
            question_id:this.state.question.question_id,
            difficulty:+this.state.question.difficulty||1,
            display_type:this.state.question.display_type,
            relate_list:relate_list,
            choice:this.state.question.choice||'0',
        }
        axios.post(URL,data).then((res)=>{
            res = res.data
            if (res.code === 0) {
                message.success(res.message);
                cb&&cb()
            }else{
                message.error(res.message);
            }
        },(error)=>{
            message.error('网络错误！');
        });

    }

    render() {

        if(!this.state.question.question_id){

            return <div>
                <Col span={14} style={{ height: '100%'}}>
                    <div>
                        暂无题目
                    </div>
                </Col>
                <Col span={10}>
                    <div>
                        暂无题目
                    </div>
                </Col>
            </div>
        }
        return (

            <div>
                <Col span={14} style={{ height: '100%'}}>
                    {
                        this.state.question.question_id&&
                        <div style={{padding:10,paddingRight:'20px'}}>
                            <div style={{borderBottom:'1px solid #aaa',fontSize:'15px'}}>
                                题目ID:{this.state.question.question_id}
                            </div>
                            <Question data={this.state.question} />
                        </div>
                    }

                </Col>
                <Col span={10}>
                    <div style={{padding:10}}>
                        <div style={{borderBottom:'1px solid #aaa',fontSize:'15px'}}>
                            题目详情
                        </div>
                        <div style={{padding:5}}>

                            <div>
                                <Row>
                                    <span style={{fontSize:13}}>题目难度：</span>
                                    <span>
                                        <Rate  onChange= {(val)=>{this.state.question.difficulty=val;this.forceUpdate()}}  value={ +this.state.question.difficulty||1 }count={4} disabled={this.props.scene==='lookTask'}/>
                                    </span>


                                </Row>
                                {/*<Row>*/}
                                    {/*<span style={{fontSize:13}}>分类：</span>*/}
                                    {/*<span>*/}
                                        {/*{*/}
                                            {/*this.state.question.choicelist&&*/}
                                            {/*<Radio.Group onChange={(e)=>{this.state.question.choice=e.target.value;this.forceUpdate()}} value={''+this.state.question.choice||'0'} disabled={this.props.scene==='lookTask'}>*/}
                                                {/*{*/}
                                                    {/*Object.keys(this.state.question.choicelist).map((key)=>{*/}
                                                        {/*if(key !== '99'){*/}
                                                            {/*return <Radio key={key} value={key}>{this.state.question.choicelist[key]}</Radio>*/}
                                                        {/*}else{*/}
                                                            {/*return null*/}
                                                        {/*}*/}
                                                    {/*})*/}
                                                {/*}*/}
                                            {/*</Radio.Group>*/}
                                        {/*}*/}
                                    {/*</span>*/}
                                {/*</Row>*/}
                                <Row>
                                    <span style={{fontSize:13}}>展示类型：</span>
                                    {console.log(this.state.question.displaytypelist)}
                                    <span>
                                        {
                                            this.state.question.displaytypelist&&
                                            <Select  value={this.state.question.display_type} style={{width: 80, marginLeft: 5}} onSelect={(val)=>{this.state.question.display_type=val;this.forceUpdate()}}>
                                                {
                                                    this.state.question.displaytypelist.map((val,k)=>
                                                        <Select.Option key={''+k+Math.random()} value={val.id}>{val.name}</Select.Option>
                                                    )
                                                }
                                            </Select>
                                        }
                                    </span>
                                </Row>
                                {
                                    this.state.question.select&&this.state.question.select.length&&
                                        this.state.question.select.map((val,k)=>
                                            <Row key={k}>
                                                <KnowledgeBox data={val}
                                                              select={this.state.question.select}
                                                              historyData={this.state.question.recomend[val.type]}
                                                              isTask={'noTask'}
                                                              ></KnowledgeBox>
                                            </Row>
                                        )

                                }

                            </div>
                        </div>
                        {
                            <div style={{textAlign:'right'}}>
                                <Button style={{marginLeft:10}} onClick={ ()=>{ window.open(window.location.origin + `/question.html#/questionmanage/fillin/${this.state.question.question_id}`)} }>改题</Button>

                                <Button style={{marginLeft:10}} onClick={()=>{this.setTag()}}>提交</Button>
                            </div>
                        }
                    </div>
                </Col>
            </div>
        )
    }
}

const mapStateTopProps = state => {
    return {

    }
}
const mapDispatchToProps = dispatch => {
    return {

    }
};
export default connect(mapStateTopProps, mapDispatchToProps)(HitTag);


// WEBPACK FOOTER //
// ./src/entry_app/question_manage/look_over_question/question_set_tag/view.js